import Controller from '../../shared/logic/Controller';
import Account from '../../shared/model/account/Account';

export const className = 'Accounts';
export const dependenciesRunInState = '--NA';
export const fields = {
  list: ['id', { user: ['avatar', 'firstName', 'lastName'] }, 'externalReferenceId']
};

export default class Accounts extends Controller {
  run = async (dependencies, dependenciesForAngular) => {
    const isInRunnableState = await this.init(
      [],
      dependencies,
      dependenciesForAngular,
      dependenciesRunInState
    );
    if (!isInRunnableState) {
      return;
    }
    this.Scope.set(
      {
        isReady: { Accounts: true }
      },
      true
    );
  };

  constructor(
    $rootScope,
    $scope,
    $state,
    $timeout,
    webpage,
    eventService,
    authenticationService
  ) {
    'ngInject';

    const angularDependencies = [
      $rootScope,
      $scope,
      $state,
      $timeout,
      webpage,
      eventService,
      authenticationService
    ];
    super(angularDependencies, {
      Storage: {
        Table: className
      },
      Scope: {
        Defaults: {
          Name: className
        }
      },
      Data: {
        Model: Account,
        ModelName: className,
        Requests: {
          available: {
            url: '/api/v1/accounts/available/',
            query: {
              fields: JSON.stringify(fields.list),
              orderBy: 'name',
              coerceTo: 'string',
              isDescending: false
            }
          },
          specific: {
            url: '/api/v1/accounts/specific/',
            method: 'GET',
            header: {
              Authorization: `Bearer ${authenticationService.tokenGet()}`
            },
            query: {
              fields: JSON.stringify(fields.list),
              coerceTo: 'string',
              isDescending: false
            }
          }
        }
      }
    });

    this.run([], angularDependencies);
  }
}
